import { useMemo } from 'react';
import {
  usePowerAppsParseQueryParams,
  usePowerAppsUpdateQueryParamNavigation,
} from './hooks/usePowerAppsDeepNavigation';

export const usePowerAppsUrl = (srcUrl: string) => {
  const { getPASrcUrl } = usePowerAppsParseQueryParams();
  const srcPAUrl = useMemo(() => getPASrcUrl(srcUrl), [getPASrcUrl, srcUrl]);
  // const [srcPowerAppUrl, setSrcPowerAppUrl] = useState(getPASrcUrl(srcUrl));

  // const [rerender, forceRender] = useState(0);

  // useEffect(() => {
  //   const nextSrcPowerAppUrl = getPASrcUrl(srcUrl);

  //   if (srcPowerAppUrl !== nextSrcPowerAppUrl) {
  //     setSrcPowerAppUrl(nextSrcPowerAppUrl);
  //     forceRender((prev) => prev + 1);
  //   }
  // }, [srcUrl, getPASrcUrl, srcPowerAppUrl]);

  usePowerAppsUpdateQueryParamNavigation(srcUrl);

  return { srcUrl: srcPAUrl };
};
